/// <amd-module name="Artifacts/Npm/commands/Deprecate" />

import { IDeprecateActionPayload, NpmActions } from "Artifacts/Npm/redux";
import { FeedOperationPermissions } from "Artifacts/Root/Constants";
import * as Tags from "Artifacts/Root/protocols/TagConstants";
import { ICommand } from "Artifacts/Root/protocols/types";
import { getStore } from "Artifacts/Root/Redux";
import * as Res from "Artifacts/Root/Resources";
import { IPackageVersionIdentity } from "Artifacts/Root/types";
import * as StringUtils from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";

export function createDeprecateCommand(
  pageContext: IVssPageContext,
  versions: IPackageVersionIdentity[],
): ICommand | undefined {
  if (versions.filter((x) => x.isDeleted).length > 0 || versions.length === 0) {
    return undefined;
  }
  const store = getStore(pageContext);
  const dispatch = store.dispatch;

  return {
    id: "deprecate",
    displayName: Res.DeprecateCommand,
    action: (payload: IDeprecateActionPayload) => {
      const feed = payload && payload.feed;
      const deprecateMessage = payload && payload.deprecateMessage;
      const onSuccessCallback = payload && payload.onSuccessCallback;
      if (feed === undefined || typeof feed !== "object") {
        throw new Error(StringUtils.format(Res.InvalidFeedParameter_Command, "deprecate"));
      }

      if (deprecateMessage === undefined || typeof deprecateMessage !== "string") {
        throw new Error(StringUtils.format(Res.InvalidCallbackParameter_Command, "deprecate"));
      }

      dispatch(NpmActions.deprecate(feed, versions, deprecateMessage, onSuccessCallback));
    },
    iconProps: {
      iconName: "SkypeMinus",
    },
    tags: new Set<string>([Tags.PackageList, Tags.PackageDetails]),
    isAnonymousAllowed: false,
    permissionBitMask: FeedOperationPermissions.DelistPackage,
  };
}
